<template>
<!-- 搜索律所 -->
  <div class="bgf8">
      <div class="pt40">
        <seafirmsmenu class="bgff" />
      </div>
      <seafirmscont />
  </div>
</template>

<script>
import seafirmsmenu from './child/seafirmsmenu'
import seafirmscont from './child/seafirmscont'
export default {
    components:{
        seafirmsmenu,
        seafirmscont
    }
}
</script>

<style lang="scss" scoped>
.bgf8{
    background-color: #F8F8F8;
    .pt40{
        padding-top: 40px;
    }
    .bgff{
        background-color: #fff;
    }
}
</style>